// extracted by mini-css-extract-plugin
export var pageContainer = "_m-1";
export var settingsContent = "_m-0";